import * as actionTypes from "./actionTypes";

const initialState = {
  data: null,
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET:
    case actionTypes.MODIFY:
      return { ...state, isLoading: true };

    case actionTypes.GET_FULFILLED:
    case actionTypes.MODIFY_FULFILLED:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
      };

    case actionTypes.GET_REJECTED:
    case actionTypes.MODIFY_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
